import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { Stack } from "@mui/material";
import TextField from "@mui/material/TextField";
import { useMsal } from "@azure/msal-react";
import { useDispatch, useSelector } from "react-redux";
import { saveNewCourse } from "../app/DeliveryLeadershipSlice";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 0,
            top: 0,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          {/* <CloseIcon /> */}
          <img
            src="/images/Home/close_img.png"
            alt="icon"
            className="form_close_img"
          />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};
const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText("#7500C0"),
  backgroundColor: "#7500C0",
  "&:hover": {
    backgroundColor: "#7500C0",
    color: "#fff",
  },
}));
function AddMorePopup(props) {
  //  const { instance } = useMsal();

  //  const activeAccount = instance.getActiveAccount();
  //    const [username, setuserName] = useState("");
  const [courseName, setCourseName] = useState("");
  const [courseCode, setCourseCode] = useState("");
  const [courseHour, setCourseHour] = useState("");
  const [audienceLevel, setAudienceLevel] = useState("");
  const [programOwner, setProgramOwner] = useState("");
  const [SME, setSME] = useState("");
  const [isCourseNameNull, setIsCourseNameNull] = useState(false);
  const [isCourseCodeNull, setIsCourseCodeNull] = useState(false);
  const [isCourseHourNull, setIsCourseHourNull] = useState(false);
  const [isSMENull, setIsSMENull] = useState(false);

  const dispatch = useDispatch();
   const { isLoaded, isDataSentSuccess, isDataSentFailure } =
      useSelector((state) => state.deliveryLeadership) ?? false;

  const handleClose = () => {
    props.setOpenAddMore(false);
    setIsCourseNameNull(false);
    setIsCourseCodeNull(false);
    setIsCourseHourNull(false);
    setIsSMENull(false);
    setCourseName("");
    setCourseCode("");
    setCourseHour("");
    setSME("");
  };
  //  function to save the qa's
  const saveHandle = () => {
    if (courseName == "") {
      setIsCourseNameNull(true);
    }
    if (courseCode == "") {
      setIsCourseCodeNull(true);
    }
    if (courseHour == "") {
      setIsCourseHourNull(true);
    }
    // if (SME == "") {
    //   setIsSMENull(true);
    // }
    if (courseName != "" && courseCode != "" && courseHour != "") {
      props.setOpenAddMore(false);
      dispatch(
        saveNewCourse(
          courseCode,
          courseName,
          courseHour,
          audienceLevel,
          programOwner
        )
      );
      setIsCourseNameNull(false);
      setIsCourseCodeNull(false);
      setIsCourseHourNull(false);
      setIsSMENull(false);
      setCourseName("");
      setCourseCode("");
      setCourseHour("");
      setSME("");
      setAudienceLevel("");
      setProgramOwner("");
        if(isDataSentSuccess){
        props.setSeverity("success");
        props.setUploadStatusMsg("Course added successfully");
      } else{
      props.setSeverity("error");
      props.setUploadStatusMsg("Failed to add course. Please try again.");
    }
    }

  };

  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={props.openAddMore}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          className="popup"
          sx={{
            fontSize: "16px",
            fontWeight: "600",
            textAlign: "center",
            paddingBottom: "0px !important",
          }}
          onClose={handleClose}
        >
          Add New Course
        </BootstrapDialogTitle>
        <DialogContent sx={{ paddingTop: "15px", width: "600px" }}>
          <Stack sx={{ padding: "10px", marginTop: "10px" }} spacing={2}>
            <Stack spacing={1}>
              <Typography sx={{ fontSize: "14px" }}>
                Course Code <span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                error={isCourseCodeNull ? true : false}
                required={isCourseCodeNull ? false : true}
                className="coursecode-textfield"
                size="small"
                fullWidth
                multiline
                id={isCourseCodeNull ? "outlined-error" : "outlined-required"}
                variant="outlined"
                helperText={
                  isCourseCodeNull ? "Please enter the course code" : null
                }
                onChange={(e) => {
                  setCourseCode(e.target.value.trim());
                  if (courseCode !== "") {
                    setIsCourseCodeNull(false);
                  }
                }}
                sx={{ width: "100%", fontSize: "14px !important" }}
                //value={props.editQuestion}
              />
            </Stack>
            <Stack spacing={1}>
              <Typography sx={{ fontSize: "14px" }}>
                Course Name <span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                error={isCourseNameNull ? true : false}
                required={isCourseNameNull ? false : true}
                className="coursename-textfield"
                fullWidth
                multiline
                size="small"
                id={isCourseNameNull ? "outlined-error" : "outlined-required"}
                variant="outlined"
                helperText={
                  isCourseNameNull ? "Please enter the course name" : null
                }
                onChange={(e) => {
                  setCourseName(e.target.value.trim());
                  if (courseName !== "") {
                    setIsCourseNameNull(false);
                  }
                }}
                sx={{ width: "100%", fontSize: "14px !important" }}
                //value={props.editQuestion}
              />
            </Stack>
            <Stack
              direction={"row"}
              spacing={4}
              justifyContent={"space-between"}
            >
              <Stack spacing={1} sx={{ width: "25%" }}>
                <Typography sx={{ fontSize: "14px" }}>
                  Course Hour<span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  error={isCourseHourNull ? true : false}
                  required={isCourseHourNull ? false : true}
                  type="number"
                  size="small"
                  onChange={(e) => {
                    setCourseHour(e.target.value.trim());
                    if (courseHour !== "") {
                      setIsCourseHourNull(false);
                    }
                  }}
                  inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                />
              </Stack>
              {/* <Stack spacing={1} sx={{ width: "60%" }}> */}
              {/*   <Typography sx={{ fontSize: "14px" }}> */}
              {/*     Approver Id */}
              {/*     <span style={{ color: "red" }}>*</span> */}
              {/*   </Typography> */}
              {/*   <TextField */}
              {/*     error={isSMENull ? true : false} */}
              {/*     required={isSMENull ? false : true} */}
              {/*     className="coursecode-textfield" */}
              {/*     size="small" */}
              {/*     fullWidth */}
              {/*     multiline */}
              {/*     id={isSMENull ? "outlined-error" : "outlined-required"} */}
              {/*     variant="outlined" */}
              {/*     helperText={ */}
              {/*       isSMENull ? "Please enter the enterprise id" : null */}
              {/*     } */}
              {/*     onChange={(e) => { */}
              {/*       setSME(e.target.value.trim()); */}
              {/*       if (SME !== "") { */}
              {/*         setIsSMENull(false); */}
              {/*       } */}
              {/*     }} */}
              {/*     sx={{ width: "100%", fontSize: "14px !important" }} */}
              {/*     //value={props.editQuestion} */}
              {/*   /> */}
              {/* </Stack> */}
            </Stack>
          </Stack>

          {/* {newQuestion} */}
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <ColorButton
            variant="contained"
            className="cancel-button"
            size="small"
            sx={{
              background: "white",
              color: "#7500C0",
              border: "solid 1px #7500C0",
            }}
            autoFocus
            onClick={handleClose}
          >
            Cancel
          </ColorButton>
          <ColorButton
            variant="contained"
            className="save-button"
            size="small"
            sx={{ background: "#7500C0", color: "white" }}
            autoFocus
            onClick={saveHandle}
          >
            Submit
          </ColorButton>
          {/* <Button autoFocus onClick={addMoreQuestion}>
      AddMore
     </Button> */}
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}

export default AddMorePopup;
